document.addEventListener('DOMContentLoaded', () => {
  const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const parent = trigger.closest('[data-accordion-item]');
      const content = parent.querySelector('[data-accordion-content]');
      parent.classList.toggle('is-open');
      if (parent.classList.contains('is-open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = null;
      }
    });
  });

  const header = document.querySelector('.site-header');
  let lastY = window.scrollY;
  
  // Mobile Navigation Drawer Toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-mobile-overlay]');

  const openDrawer = () => {
    if (drawer && overlay) {
      drawer.classList.add('is-active');
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeDrawer = () => {
    if (drawer && overlay) {
      drawer.classList.remove('is-active');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  };

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  if (menuClose) menuClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  const searchOpen = document.querySelector('[data-search-open]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchInput = document.querySelector('[data-search-input]');

  const openSearch = () => {
    if (!searchPanel) return;
    searchPanel.classList.add('is-active');
    searchPanel.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => {
      if (searchInput) searchInput.focus();
    }, 50);
  };

  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-active');
    searchPanel.setAttribute('aria-hidden', 'true');
  };

  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSearch();
  });

  const handleScroll = () => {
    const currentY = window.scrollY;
    if (!header) return;
    
    // Add/remove scrolled class for overlay to sticky conversion
    if (currentY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    
    // Hide header when scrolling down, show when scrolling up
    if (currentY > lastY && currentY > 150) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }
    
    lastY = currentY;
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll(); // Run once initially on load

  const loadMoreBtns = document.querySelectorAll('.collection-pagination__btn');
  loadMoreBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const url = btn.href;
      const collectionMain = btn.closest('.collection-main');
      const collectionGrid = collectionMain ? collectionMain.querySelector('.collection-grid') : null;
      const paginationContainer = btn.closest('.collection-pagination');
      
      if (!url || !collectionGrid) return;
      
      btn.textContent = 'LOADING...';
      btn.style.pointerEvents = 'none';
      
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const newMain = doc.querySelector('.collection-main');
          const newGrid = newMain ? newMain.querySelector('.collection-grid') : null;
          const newProducts = newGrid ? newGrid.querySelectorAll('.collection-product-card') : [];
          
          if (newProducts.length > 0) {
            newProducts.forEach((product) => {
              collectionGrid.appendChild(product.cloneNode(true));
            });
            syncWishlistButtons();
          }
          
          const newPagination = newMain ? newMain.querySelector('.collection-pagination') : null;
          if (newPagination && paginationContainer) {
            const newStatus = newPagination.querySelector('.collection-pagination__status');
            const newProgress = newPagination.querySelector('.collection-pagination__progress-bar');
            const newBtn = newPagination.querySelector('.collection-pagination__btn');
            
            const currentStatus = paginationContainer.querySelector('.collection-pagination__status');
            const currentProgress = paginationContainer.querySelector('.collection-pagination__progress-bar');
            
            if (newStatus && currentStatus) {
              const totalMatch = newStatus.textContent.match(/of\s+(\d+)\s+products/i);
              const totalCount = totalMatch ? Number(totalMatch[1]) : collectionGrid.querySelectorAll('.collection-product-card').length;
              const loadedCount = collectionGrid.querySelectorAll('.collection-product-card').length;
              currentStatus.textContent = `Showing ${loadedCount} of ${totalCount} products`;
            }
            if (newProgress && currentProgress) {
              const totalMatch = newStatus ? newStatus.textContent.match(/of\s+(\d+)\s+products/i) : null;
              const totalCount = totalMatch ? Number(totalMatch[1]) : collectionGrid.querySelectorAll('.collection-product-card').length;
              const loadedCount = collectionGrid.querySelectorAll('.collection-product-card').length;
              currentProgress.style.width = `${Math.min((loadedCount / totalCount) * 100, 100)}%`;
            }
            
            if (newBtn) {
              btn.href = newBtn.href;
              btn.textContent = 'LOAD MORE ITEMS';
              btn.style.pointerEvents = '';
            } else {
              btn.remove();
            }
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          btn.textContent = 'LOAD MORE ITEMS';
          btn.style.pointerEvents = '';
        });
    });
  });

  const wishlistKey = 'azureWishlist';
  const wishlistGrid = document.querySelector('[data-wishlist-grid]');
  const wishlistEmpty = document.querySelector('[data-wishlist-empty]');

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    window.localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const escapeWishlistText = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const syncWishlistButtons = () => {
    const items = readWishlist();
    const wishlistButtons = document.querySelectorAll('[data-wishlist-toggle]');
    wishlistButtons.forEach((button) => {
      const handle = button.dataset.productHandle;
      const isSaved = items.some((item) => item.handle === handle);
      button.classList.toggle('is-active', isSaved);
      button.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Add to wishlist');
    });
  };

  const renderWishlist = () => {
    if (!wishlistGrid) return;
    const items = readWishlist();
    wishlistGrid.innerHTML = '';
    if (wishlistEmpty) wishlistEmpty.hidden = items.length > 0;
    wishlistGrid.hidden = items.length === 0;

    items.forEach((item) => {
      const title = escapeWishlistText(item.title || 'Azure product');
      const price = escapeWishlistText(item.price || '');
      const url = escapeWishlistText(item.url || '#');
      const image = escapeWishlistText(item.image || '');
      const handle = escapeWishlistText(item.handle || '');
      const variantId = escapeWishlistText(item.variantId || '');
      const card = document.createElement('article');
      card.className = 'wishlist-card';
      card.innerHTML = `
        <div class="wishlist-card__link">
          <div class="wishlist-card__media product-card-media">
            <a href="${url}" class="product-card-media__link" aria-label="${title}">
            ${image ? `<img src="${image}" alt="${title}">` : '<div class="wishlist-card__placeholder"></div>'}
            </a>
            <div class="product-card-actions">
              <div class="product-card-actions__icons">
                <a href="${url}" class="product-card-action product-card-action--icon" aria-label="View ${title}">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="3"/></svg>
                </a>
                <button type="button" class="product-card-action product-card-action--icon" aria-label="Remove ${title} from wishlist" data-wishlist-remove="${handle}">
                  <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 2.8 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3.1-5.8 3.1 1.1-6.5-4.7-4.6 6.5-.9L12 2.8Z"/></svg>
                </button>
              </div>
              ${variantId ? `<form class="product-card-actions__form" action="/cart/add" method="post"><input type="hidden" name="id" value="${variantId}"><input type="hidden" name="quantity" value="1"><button type="submit" class="product-card-action product-card-action--cart">ADD TO CART</button></form>` : ''}
            </div>
          </div>
          <h2><a href="${url}">${title}</a></h2>
          <p>${price}</p>
        </div>
        <button type="button" class="wishlist-card__remove" data-wishlist-remove="${handle}">Remove</button>
      `;
      wishlistGrid.appendChild(card);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const items = readWishlist();
    const existingIndex = items.findIndex((item) => item.handle === handle);
    if (existingIndex > -1) {
      items.splice(existingIndex, 1);
    } else {
      items.unshift({
        handle,
        title: button.dataset.productTitle || 'Azure product',
        url: button.dataset.productUrl || '#',
        price: button.dataset.productPrice || '',
        variantId: button.dataset.productVariantId || '',
        image: button.dataset.productImage || ''
      });
    }
    writeWishlist(items);
    syncWishlistButtons();
    renderWishlist();
  });

  if (wishlistGrid) {
    wishlistGrid.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-wishlist-remove]');
      if (!removeButton) return;
      const items = readWishlist().filter((item) => item.handle !== removeButton.dataset.wishlistRemove);
      writeWishlist(items);
      renderWishlist();
      syncWishlistButtons();
    });
  }

  syncWishlistButtons();
  renderWishlist();

  document.addEventListener('submit', (event) => {
    const quickAddForm = event.target.closest('.product-card-actions__form');
    if (!quickAddForm) return;
    event.preventDefault();

    const button = quickAddForm.querySelector('.product-card-action--cart');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'ADDING...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(quickAddForm)
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add product to cart');
        return fetch('/cart.js');
      })
      .then((response) => response.json())
      .then((cart) => {
        const cartBadge = document.querySelector('[data-cart-count-badge]');
        if (cartBadge) {
          cartBadge.textContent = cart.item_count;
          cartBadge.classList.toggle('is-hidden', cart.item_count === 0);
        }
        if (button) button.textContent = 'ADDED';
      })
      .catch(() => {
        if (button) button.textContent = 'TRY AGAIN';
      })
      .finally(() => {
        if (!button) return;
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 1200);
      });
  });
});
